import { render, staticRenderFns } from "./AdminActivityInfo.vue?vue&type=template&id=5a3d6c58&scoped=true&"
import script from "./AdminActivityInfo.vue?vue&type=script&lang=js&"
export * from "./AdminActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminActivityInfo.vue?vue&type=style&index=0&id=5a3d6c58&lang=less&scoped=true&"
import style1 from "./AdminActivityInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d6c58",
  null
  
)

export default component.exports